import { useState, useEffect } from 'react';
import { LinearProgress } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

export interface InlineLoaderProps {
  loading: boolean;
  delay?: number;
  className?: string;
}

const useStyles = makeStyles({
  root: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    right: 0,
    height: 4,
  },
});

export function InlineLoader({
  loading,
  delay = 0,
  className,
}: InlineLoaderProps) {
  const classes = useStyles();
  const [showLoader, setShowLoader] = useState(false);

  useEffect(() => {
    if (!loading) {
      setShowLoader(false);
      return;
    }
    const timer = setTimeout(() => setShowLoader(true), delay);
    return () => clearTimeout(timer);
  }, [loading, delay]);

  if (!showLoader) return null;

  return (
    <LinearProgress
      className={`${classes.root} ${className || ''}`}
      data-cy="inline-loader"
    />
  );
}

export default InlineLoader;
